export const FILTER_ACTION_TYPES = {
  ADD_CATEGORIES: 'ADD_CATEGORIES',
  SET_CATEGORY: 'SET_CATEGORY',
  TOGGLE_OPTION: 'TOGGLE_OPTION',
  CLEAR_FORM: 'CLEAR_FORM', // set all option counts to 0
  UPDATE_FILTERS: 'UPDATE_FILTERS',
  CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
};
